var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector108(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.688 1.37549C5.68799 3.87549 6.18799 26.3755 14.688 29.3755M14.688 1.37549C8.95358 1.37549 4.9953 4.21726 2.86163 8.09016M14.688 1.37549C20.5818 1.37549 24.5979 4.21726 26.7364 8.09016M14.688 1.37549C25.6106 6.37549 21.188 29.3755 14.688 29.3755M14.688 1.37549V29.3755M14.688 29.3755C8.90378 29.3755 4.97694 26.6383 2.86163 22.8755M14.688 29.3755C20.4722 29.3755 24.4479 26.6383 26.6152 22.8755M2.86163 22.8755H26.6152M2.86163 22.8755C1.5942 20.6209 0.977126 17.9982 1.00054 15.3755M26.6152 22.8755C27.9137 20.6209 28.563 17.9982 28.563 15.3755M28.563 15.3755H1.00054M28.563 15.3755C28.5631 12.8356 27.9542 10.2957 26.7364 8.09016M1.00054 15.3755C1.02321 12.8356 1.64656 10.2957 2.86163 8.09016M2.86163 8.09016H26.7364",
    stroke: "#709FDC",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector108);
export default __webpack_public_path__ + "static/media/Vector108.93fac98550bcabe5ff41183cd06acdd2.svg";
export { ForwardRef as ReactComponent };